import { Monitor, Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n";
import { applyMode, nextMode, readMode, saveMode, type ThemeMode } from "@/lib/theme";
import { isTelegramLaunch, readFlag } from "@/lib/telegram";

const ICON = { system: Monitor, light: Sun, dark: Moon } as const;
const LABEL = { system: "theme.system", light: "theme.light", dark: "theme.dark" } as const;

/** Bitta tugma: tizim → yorug' → qorong'i → tizim. "Tizim" rejimida qurilma sozlamasi o'zgarsa darhol ergashadi. */
export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useT();
  const [mode, setMode] = useState<ThemeMode>(readMode);
  // Telegram ichida mavzuni Telegram o'zi beradi (TelegramBridge): bu tugma aralashmaydi
  const inTelegram = isTelegramLaunch(window.location.hash, readFlag());

  useEffect(() => {
    if (inTelegram) return;
    applyMode(mode);
    if (mode !== "system" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const on = () => applyMode("system");
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [mode, inTelegram]);

  if (inTelegram) return null;
  const Icon = ICON[mode];
  return (
    <Button
      variant="ghost"
      size="icon"
      className={className}
      aria-label={`${t("theme.title")}: ${t(LABEL[mode])}`}
      title={`${t("theme.title")}: ${t(LABEL[mode])}`}
      onClick={() => {
        const n = nextMode(mode);
        saveMode(n);
        setMode(n);
      }}
    >
      <Icon className="size-5" />
    </Button>
  );
}
